// extracted by mini-css-extract-plugin
module.exports = {"btn":"AppointmentButtons_btn__A3Dfn","hide":"AppointmentButtons_hide__S58AQ"};